import clsx from 'clsx'
import React, { FC, useState } from 'react'
import { HeaderLanguage, HeaderUserMenu } from '../../../partials'
import { HeaderLocationsMenu } from '../../../partials/layout/header-menus/HeaderLocationsMenu'
import { KTSVG } from '../../../helpers'
import ThemeToggle from '../ThemeToggle'  // ← YENİ

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const [clickCapture, setClickCapture] = useState(false)
  const handleClick = () => {
    setClickCapture(!clickCapture)
  }

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>

      {/* ── TEMA TOGGLE ── */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <ThemeToggle />
      </div>
      {/* ── END TEMA TOGGLE ── */}

      {/* LOCATIONS */}
      <div
        onClick={handleClick}
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          className={clsx(
            'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG path='/media/icons/bootstrap/header/geo-alt-fill.svg' className='svg-icon-2' />
        </div>
        <HeaderLocationsMenu test={clickCapture} />
      </div>
      {/* END LOCATIONS */}


      {/* begin::Language */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          className={clsx(
            'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG path='/media/icons/bootstrap/header/globe2.svg' className='svg-icon-2' />
        </div>
        <HeaderLanguage />
      </div>
      {/* end::language */}

      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          className={clsx(
            'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG path='/media/icons/bootstrap/header/person-fill.svg' className='svg-icon-1' />
        </div>
        <HeaderUserMenu />
      </div>
      {/* end::User */}

    </div>
  )
}

export { Topbar }